'use strict';

angular.module('upDirectives').directive('upAccountChartSales', function () {
	return {
		restrict: 'A',
		template: '<div></div>',
		link: function ($scope, $element, $attr) {
			let firstElement = $element[0];
			var chartConfig;
			var renderTimeout;
			var renderChart = function () {
				if (renderTimeout) {
					clearTimeout(renderTimeout);
				}

				renderTimeout = setTimeout(function () {
					if (chartConfig && firstElement) {
						var graphComponent = $attr.isMarket
							? ReactTemplates.reportAccountMarket
							: ReactTemplates.reportAccountSales;
						_getOrCreateRoot(firstElement).render(
							React.createElement(graphComponent, {
								// Chart data and stuff
								config: chartConfig,

								// Injects
								tools: {}
							})
						);
					}
				}, 20);
			};

			$scope.$on('$destroy', function () {
				_unmountRoot(firstElement);
				firstElement = undefined;
			});

			$scope.$watch(
				$attr.chart,
				function (config) {
					chartConfig = config;
					renderChart();
				},
				true
			);
		}
	};
});
